module.exports = __webpack_public_path__ + "img/icn_edit.866894c0.svg";